module.exports = __webpack_public_path__ + "media/images/noticia03-3-0049aba505b98d3ab650071f60abd7c9.jpeg";